import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import planSlice from './slices/planSlice';
import sessionSlice from './slices/sessionSlice';
import exerciseSlice from './slices/exerciseSlice';
import adminSlice from './slices/adminSlice';
import trainerSlice from './slices/trainerSlice';
import memberSlice from './slices/memberSlice';
import chatSlice from './slices/chatSlice';
import uiSlice from './slices/uiSlice';
import shopSlice from './slices/shopSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    plans: planSlice,
    sessions: sessionSlice,
    exercises: exerciseSlice,
    admin: adminSlice,
    trainer: trainerSlice,
    member: memberSlice,
    chat: chatSlice,
    ui: uiSlice,
    shop: shopSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});